import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicModule } from 'ionic-angular';
import { ControlsModule } from '../../controls/controls.module';
import { TabindexDirective } from '../../directives/tabindex.directive';
import { FieldWrapperComponent } from './field-wrapper.component';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule.forChild(),
        ControlsModule
    ],
    declarations: [
        FieldWrapperComponent,
        TabindexDirective
    ],
    exports: [
        FieldWrapperComponent,
        ControlsModule
    ],
    entryComponents: [
        FieldWrapperComponent
    ]
})
export class FieldWrapperModule {

}



// WEBPACK FOOTER //
// ./src/vas/modules-shared/field-wrapper/field-wrapper.module.ts